<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="iii" class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span>New Orleans and the Creation of Transatlantic Opera, 1819–1859</h1>
<p class="bkau">Charlotte Bentley</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago &amp; London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-bentley-0004.vue?13f83d92